
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { 
  // Feature,
  FeatureBase,
  // Limitation 
} from "@models";
import { GameClass } from "@dndModels/feature_sources/GameClass";
import { SubclassFeature } from "@dndModels/feature/SystemFloatingFeature";
import DandDAPI from "@utilities/smart_api";
import { DataType } from "@dndModels/Types";
import CommonUtilities from "@utilities/common_utilities";

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();

export class Subclass extends DandDFeatureSource {
  data_type: DataType = "subclass";
  feature_source_type = "Subclass";
  game_class_id = "";
  // use_subclass_levels = false;

  game_class?: GameClass;

  get class_name() {
    return this.game_class?.name??"";
  }

  get linkifiedName() {
    return `${common_util.makeStringLinkReady(this.name)}_(${common_util.makeStringLinkReady(this.class_name)})`;
  }

  constructor(obj?: any) {
    super(obj, "Subclass");
    if (obj) {
      this.game_class_id = obj.game_class_id ? obj.game_class_id : "";
      // this.use_subclass_levels = obj.use_subclass_levels ? obj.use_subclass_levels : false;
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature_base = new FeatureBase(o);
          this.feature_bases.push(feature_base);
        });
      }
    }
  }

  get_detail_format() {
    const str = `${super.get_detail_format()}; {list_of_type:game_class;[${this.game_class_id}]}`;
    return str.trim();
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.game_class_id = obj.game_class_id ? obj.game_class_id : "";
  //     this.use_subclass_levels = obj.use_subclass_levels ? obj.use_subclass_levels : false;
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature_base = new FeatureBase(o);
  //         this.feature_bases.push(feature_base);
  //       });
  //     }
  //   }
  // }

  get_homebrewery_string(): string {
    let str = `# ${this.true_name}\n\r`;
    str += `${this.description}\n\r`;
    const game_class = (api.getDataTypeFromHash<GameClass>("game_class")).find(o => o._id === this.game_class_id);
    if (game_class) {
      str += `#### ${game_class.true_name} Subclass\n\r`;
    }
    str += this.get_homebrewery_fbs_string();
    return str;
  }

  get_homebrewery_fbs_string(): string {
    let str = "";
    const fbs = this.feature_bases.sort((a, b) => {
      if (a.level === b.level) {
        return a.fb_name.localeCompare(b.fb_name);
      } else {
        return +a.level < +b.level ? -1 : 1;
      }
    });
    const game_class = (api.getDataTypeFromHash<GameClass>("game_class")).find(o => o._id === this.game_class_id);
    if (game_class) {
      const subclass_fbs = game_class.feature_bases.filter(o => o.features.find(o => o.floating_feature instanceof SubclassFeature));
      let level = 0;
      for (const fb of fbs) {
        if (level !== fb.level) {
          level = fb.level;
          // if (this.use_subclass_levels) {
             
          //   const subclass_fb = subclass_fbs.find(o => o.features.find(o => o.floating_feature instanceof SubclassFeature && o.floating_feature.level === level));
          //   if (subclass_fb) {
          //     str += `## Level ${subclass_fb.level}\n\r`;
          //   }
          // } else {
          str += `## Level ${level}\n\r`;
          // }
        }
        str += `### ${fb.fb_name}\n\r`;
        str += `${fb.description}\n\r`;
      }
      // const ofbs = api.get_optional_features([this]).sort((a, b) => {
      //   if (a.level === b.level) {
      //     return a.name.localeCompare(b.name);
      //   } else {
      //     return +a.level < +b.level ? -1 : 1;
      //   }
      // });
      // if (ofbs.length > 0) {
      //   level = 0;
      //   str += `# Optional Features\n\r`;
      //   for (const fb of ofbs) {
      //     if (level !== fb.level) {
      //       level = fb.level;
      //       if (this.use_subclass_levels) {
      //         // eslint-disable-next-line
      //         const subclass_fb = subclass_fbs.find(o => o.features.find(o => o.floating_feature instanceof SubclassFeature && o.floating_feature.level === level));
      //         if (subclass_fb) {
      //           str += `## Level ${subclass_fb.level}\n\r`;
      //         }
      //       } else {
      //         str += `## Level ${level}\n\r`;
      //       }
      //     }
      //     str += `### ${fb.name}\n\r`;
      //     str += `${fb.description}\n\r`;
      //   }
      // }
    }
    return str;
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      game_class_id: this.game_class_id,
      // use_subclass_levels: this.use_subclass_levels
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      game_class_id: this.game_class_id,
      // use_subclass_levels: this.use_subclass_levels
    };
  }

  copy(copyMe: Subclass, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.game_class_id = copyMe.game_class_id;
    // this.use_subclass_levels = copyMe.use_subclass_levels;
  }

  clone(drop_ids = false): Subclass {
    const new_obj = new Subclass();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy5e(copyMe: any): void {
    console.log(copyMe);
    this.name = copyMe.name;
    this.description = "";
    copyMe.desc.forEach((d: string) => {
      this.description += d + "\n ";
    });
  }
}